import { v4 as uuidV4 } from 'uuid';
import { asyncRequestHeader, responseHeader, subscribeMessageHeader, syncRequestHeader } from './const';

export function _generateSubscribeMethod(method) {
  return subscribeMessageHeader + method;
}
export function _getRealMethodFromRequest(method) {
  const requestHeader = method.indexOf(asyncRequestHeader) === 0 ? asyncRequestHeader : syncRequestHeader;
  return method.split(requestHeader)[1];
}

export function _isRequest(method) {
  return method.indexOf(asyncRequestHeader) === 0 || method.indexOf(syncRequestHeader) === 0;
}

export function _isRequestRespones(method) {
  return method.indexOf(responseHeader) === 0;
}

export function _isSubscribeMessage(method) {
  return method.indexOf(subscribeMessageHeader) === 0;
}

export function _generateMessageData(async, method, data, customMethodHeader, customParamsName) {
  try {
    const requestId = uuidV4();
    const methodHeader = customMethodHeader || (async ? asyncRequestHeader : syncRequestHeader);
    const paramsName = customParamsName || 'params';
    const messageData = {
      method: methodHeader + method,
      requestId,
      [paramsName]: data
    };
    const request = JSON.stringify(messageData);
    return { request, requestId };
  } catch (error) {
    console.log('_generateMessageData error', error);
    throw new Error(error);
  }
}

export function _validateTarget(target) {
  if (!target) {
    throw new Error('target is not exsit');
  }
  if (!target.requestFromJS || typeof target.requestFromJS !== 'function') {
    throw new Error('function requestFromJS not exsit in target or requestFromJS is not a function');
  }
  return true;
}
